/*
 * @Author: 戴旭
 * @Date: 2023-02-17 10:10:49
 * @LastEditTime: 2023-02-17 11:09:11
 * @LastEditors: 戴旭
 * @Description: 
 * @FilePath: \p2ps_vip_web\src\router\bonus-computed\bonus-scheme\moudels\dataComputedRouter.js
 * 文件备注
 */
const dataComputedRouter = []

export default dataComputedRouter


